import { render, staticRenderFns } from "./RomaDrawer.vue?vue&type=template&id=4f63620e&"
import script from "./RomaDrawer.vue?vue&type=script&lang=js&"
export * from "./RomaDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RomaDrawer.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VNavigationDrawer})
